/* eslint-disable @typescript-eslint/no-explicit-any */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { Activity } from '../../types/ActivityTypes'

export interface ActivityState {
  scans: Activity[] | undefined
  totalPages: number
  activityTableCurrentPage: number
  threatHunterScreen: string
}

const initialState: ActivityState = {
  scans: undefined,
  totalPages: 1,
  activityTableCurrentPage: 0,
  threatHunterScreen: 'scans',
}

export const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {
    setScans(state, action: PayloadAction<any>) {
      state.scans = action.payload
    },
    setTotalPages(state, action: PayloadAction<any>) {
      state.totalPages = action.payload
    },
    setActivityTableCurrentPage(state, action: PayloadAction<any>) {
      state.activityTableCurrentPage = action.payload
    },
    setThreatHunterScreen(state, action: PayloadAction<any>) {
      state.threatHunterScreen = action.payload
    },
  },
})
export const selectActivity = (state: RootState) => state.activity

export const { setScans, setTotalPages, setActivityTableCurrentPage, setThreatHunterScreen } = activitySlice.actions
export default activitySlice.reducer
